import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { OverlayPanel } from 'primereact/overlaypanel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import GAS from "../../../GAS";

const TopicoList = ({ painel, filtroDimensoes, setDialogEditarTopico, setDialogEditarTomadasAcoes, setPainel, setEditTopico, usuario, showMessage, idSessao }) => {
    const [filtroTopicosText, setFiltroTopicosText] = useState('');
    const [filtroTopicosSentimento, setFiltroTopicosSentimento] = useState(null);
    let op;
    let dt;

    const gasObj = GAS.getInstance(); // Instância do GAS

    const itemsTopicosTipos = [
        { label: 'TODOS', value: null },
        { label: 'FRAGILIDADE', value: 'FRAGILIDADE' },
        { label: 'POTENCIALIDADE', value: 'POTENCIALIDADE' }
    ];

    const filterTopicosByState = () => {
        if (filtroDimensoes !== null) {
            return painel.topicos.filter(topico => topico.dimensaoNumero === filtroDimensoes.numero);
        }
        return [];
    };

    // Tenta pegar o lock antes de abrir qualquer modal de edição
    const tentarAdquirirLockEAbrirModal = async (topico, tipoModal, remover) => {
        let topicoEdit = JSON.parse(JSON.stringify(topico));
        topicoEdit.editIndex = painel.topicos.indexOf(topico);

        try {
            const res = await gasObj.request(
                'MCPAPainelApropriador.instance.SERVICE.GETLockTopico', 
                painel.proprietario, // emailGestor
                topico.topico,       // topicoNome 
                usuario.email,       // emailEditor
                idSessao             // Identidade única desta aba
            );
            
            // Verifica se o backend autorizou o lock
            if (res.response && res.response.sucesso) {
                if(remover === true){
                    return true;
                }
                setEditTopico(topicoEdit);
                if (tipoModal === 'topico') {
                    setDialogEditarTopico(true, topicoEdit);
                } else if (tipoModal === 'acoes') {
                    setDialogEditarTomadasAcoes(true, topicoEdit);
                }
            } else {
                showMessage('warn', 'Acesso negado', `Este tópico já está sendo editado por ${res.response.bloqueadoPor}`);
            }
        } catch (error) {
            console.error("Erro ao tentar lock:", error);
            showMessage('error', 'Erro', <>
                Não foi possível acessar o tópico.
                <br />
                Por favor recarregue sua página!
                </>
            );
        }
    };

    const renderSentimento = (topico) => {  
        return (
            <span 
                style={{ fontSize: '13px', padding: "2px 3px" }} 
                className={`badge-topico text-break  ${topico.sentimento.toLowerCase()}`}
            >
                {topico.sentimento}
            </span>
        );
    };

    const renderActionsTopico = (topico) => {
        const renderButtonEditarTopico = (
            <Button className="p-button-rounded p-button-text p-button-icon-only p-button-plain" tooltipOptions={{ position: 'top' }} tooltip="Editar tópico" icon="pi pi-pencil"
                 onClick={() => tentarAdquirirLockEAbrirModal(topico, 'topico')} />
        );

        const renderEditarTomadaAcoesTopico = (
            <Button className="p-button-rounded p-button-text p-button-icon-only p-button-plain p-button-success" tooltipOptions={{ position: 'top' }} tooltip="Gerenciar ações de melhoria deste tópico" icon="pi pi-bolt"
                 onClick={() => tentarAdquirirLockEAbrirModal(topico, 'acoes')} />
        );

        const renderButtonRemover = (
            <Button className="p-button-rounded p-button-text p-button-icon-only p-button-plain p-button-danger" tooltipOptions={{ position: 'top' }} tooltip="Excluir tópico deste painel" icon="pi pi-trash"
                 onClick={async () => {
                    try {
                        const lockAdquirido = await tentarAdquirirLockEAbrirModal(topico, "", true);

                        if (!lockAdquirido) {
                            return;
                        }
                        
                        const respostaDelete = await gasObj.request(
                            'MCPAPainelApropriador.instance.SERVICE.DELETETopico',
                            painel.proprietario,
                            topico.topico,
                            usuario.email,
                            idSessao
                        );

                        if (respostaDelete.response?.sucesso === false && respostaDelete.response?.motivo === 'LOCK_PERDIDO') {
                            showMessage('error', 'Conflito de edição',
                                `Este tópico foi alterado por ${respostaDelete.response.bloqueadoPor} enquanto você tentava excluí-lo. Recarregando a página...`);
                            setTimeout(() => window.location.reload(), 2500); // dá tempo do toast aparecer antes do reload
                            return;
                        }

                        // Não é preciso chamar DELETELockTopico aqui: deletarTopico já remove
                        // o registro do tópico inteiro (splice), e o lock vive dentro desse
                        // mesmo registro — ele deixa de existir junto. Chamar DELETELockTopico
                        // depois de excluir sempre falharia com "Tópico não encontrado".

                        const painelAtualizado = { ...painel };
                        painelAtualizado.topicos = painel.topicos.filter(t => t !== topico);
                        setPainel(painelAtualizado);
                        showMessage('success', 'Removido', 'Tópico removido com sucesso.');
                    } catch (error) {
                        console.error('Erro ao remover tópico:', error);
                        showMessage('error', 'Erro', 'Não foi possível remover o tópico.');
                    }
                }} />
        );

        return (
            <span className="p-d-flex p-jc-between" >
                {renderButtonEditarTopico}
                {renderEditarTomadaAcoesTopico}
                {renderButtonRemover}
            </span>
        );
    };

    const renderTopico = (rowData) => {
        if (!rowData) return null;
        return (
            <div>
                <Tooltip target={`.tooltip-historico-${rowData.rowIndex}`}>
                    <div className='p-p-2'>
                        <small style={{ overflowWrap: 'anywhere' }}>
                            <span className='p-text-bold'>CRIADO EM</span>
                            <div>{new Date(rowData.criacao.data).toLocaleString()}</div>
                            <div className='p-text-italic p-mb-1'>{rowData.revisao.usuario}</div>
                            <span className='p-text-bold'>REVISADO EM</span>
                            <div>{new Date(rowData.revisao.data).toLocaleString()}</div>
                            <div className='p-text-italic p-mb-1'>{rowData.revisao.usuario}</div>
                        </small>
                    </div>
                </Tooltip>
                <div className={`tooltip-historico-${rowData.rowIndex}`} data-pr-position='right' data-pr-mousetrack="true">{rowData.topico}</div>
            </div>
        );
    };

    const renderAbrangencia = (topico) => {
        return (
            <div>
                <Tooltip target=".tooltip-abrangencia" />
                <i className="tooltip-abrangencia pi pi-star" data-pr-tooltip="nível organizacional do tópico" /> {topico.contexto.nivelOrganizacional}
                <br />
                <i className="tooltip-abrangencia pi pi-users" data-pr-tooltip="segmentos relacionados ao tópico" /> {topico.contexto.segmentos.join(', ')}
            </div>
        );
    };

    const topicos = filterTopicosByState();

    const header = (
        <div className="p-d-flex p-jc-between">
            <Button className="p-button-outlined" label={`⁉️ DICAS DIMENSÃO ${filtroDimensoes.numero} `} onClick={(e) => op.toggle(e)} aria-haspopup aria-controls="overlay-dica" />
            <OverlayPanel ref={(el) => op = el} id="overlay-dica" style={{ width: '50%', height: '70%', overflowY: 'auto' }}>
                <p className="p-mb-4">
                    <h3>|DIMENSÃO {filtroDimensoes.numero}| {filtroDimensoes.nome.toUpperCase()}</h3>
                    {filtroDimensoes.descricao}
                </p>
                <p className="p-mb-4">
                    <h3>DICAS PREENCHIMENTO</h3>
                    <ol style={{ '--space-between': '1.5rem', listStylePosition: 'inside', display: 'flex', flexDirection: 'column'}}>
                        <li>Adicione tópicos avaliativos nesta dimensão, que podem ser FRAGILIDADES ou POTENCIALIDADES (em seu CURSO, CAMPUS ou INSTITUIÇÃO).</li>
                        <li>Cada tópico avaliativo adicionado equivale a uma informação relevante que mereça destaque na avaliação institucional. Portanto, analise os dados disponíveis das seguintes fontes: relatórios de avaliações realizadas ou em andamento realizadas pela instituição; última avaliação realizadas pelo INEP; ou reúna reivindicações emanadas de reuniões/assembleias realizadas a comunidade. </li>
                        <li>👉 Ao adicionar tópicos como FRAGILIDADE: disponha uma ou mais ações de melhorias sobre eles, que serão monitoradas para superá-los.</li>
                        <li>👉 Ao adicionar tópicos como POTENCIALIDADE: recomenda-se dispoor uma ou mais ações para compartilhá-los ou divulgá-los com a comunidade interna ou externa.</li>
                        <li>⚠️É recomendável que a CPA da instituição ou a SPA de sua unidade oriente sobre como obter fontes de dados para adicionar tópicos avaliativos apropriadamente.
                            Logo que sua lista de tópicos estiver pronta, recomenda-se revisá-la com o NDE de seu curso (ou equivalente) e a SPA de sua unidade.</li>
                    </ol>
                </p>
            </OverlayPanel>
            <div>
                <Button tooltipOptions={{ position: 'bottom' }} label="TÓPICO" tooltip="Adiciona um tópico na lista desta dimensão avaliativa" icon="pi pi-plus"  onClick={() => {
                    setEditTopico(null);
                    setDialogEditarTopico(true, { editIndex: false });
                }} />
            </div>
        </div>
    );

    const filterTopico = (
        <div className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText style={{ width: "100%" }} type="search" value={filtroTopicosText || ''} onInput={(e) => {
                dt.filter(e.target.value, 'topico', 'contains');
                setFiltroTopicosText(e.target.value)
            }} placeholder="buscar..." />
        </div>
    );

    const filterSentimento = (
        <Dropdown showClear value={filtroTopicosSentimento} options={itemsTopicosTipos} onChange={(e) => {
            dt.filter(e.value, 'sentimento', 'equals');
            setFiltroTopicosSentimento(e.value)
        }} />
    );

    return (
        <div className="topicos">
            <DataTable
                stripedRows
                showGridlines
                ref={(el) => dt = el}
                value={topicos}
                columnResizeMode="fit"
                header={header}
                emptyMessage="sem tópicos cadastrados!"
            >
                <Column style={{ width: '25%', wordWrap: "break-word" }} header="Topico" field="topico"  body={(rowData) => renderTopico(rowData)}  filter filterElement={filterTopico}/>
                <Column style={{ width: '17.0%', wordWrap: "break-word" }} header="Sentimento" field="sentimento" body={renderSentimento} filter filterElement={filterSentimento}/>
                <Column style={{ width: '17.5%' }} header="Abrangência" body={renderAbrangencia}/>
                <Column style={{ width: '15%' }} header="Ações" body={renderActionsTopico}></Column>
            </DataTable>
        </div>
    );
};

export default TopicoList;